<script>
    
    import { toast } from 'bulma-toast'
    import { FixedpricesStore, FixedpriceStore, ModalStore } from '../stores'
    
    import FixedpricesService from '../$services/fixedprices.service'
    import NumeralMethods from '../$methods/numeral.methods'
    import DateMethods from '../$methods/date.methods'
    import EnumMethods from '../$methods/enum.methods'

    import Pagination from '../$components/pagination.header.svelte'
    import Search from '../$components/search.svelte'
    import Table from '../$components/table.svelte'
    import Icon from '../$components/icon.svelte'

    let loading = false
    let metadata = {}
    let query = {}

    getFixedprices()

    async function getFixedprices() {

        loading = true
        const resp = await FixedpricesService.getFixedprices(query)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        metadata = resp.data.metadata
        query = resp.data.query

        FixedpricesStore.set(resp.data.fixedprices)
    }

</script>

<Search bind:value={query.find} on:enter={getFixedprices} />

<div class="items end">
    <Pagination bind:metadata bind:query on:change={getFixedprices} />
</div>

<Table items={ $FixedpricesStore.length } total={ metadata.total } { loading }>
    <thead>
        <tr>
            <th>#</th>
            <th>Estatus</th>
            <th>Tipo</th>
            <th>Proveedor</th>
            <th>Servicio</th>
            <th>Rango</th>
            <th>Precio</th>
            <th></th>
        </tr>
    </thead>
    <tbody>
        {#each $FixedpricesStore as fixedprice, index}
            <tr>
                <td>{ (index+1) + (query.page * metadata.limit) }</td>
                <td>{ DateMethods.isAfter(fixedprice.expired)? 'Habilidato' : 'Deshabilitado' }</td>
                <td>{ EnumMethods.get(fixedprice.type) }</td>
                <td>{ fixedprice.provider }</td>
                <td>{ fixedprice.service }</td>
                <td>{ fixedprice.type === 'national' ? `${ fixedprice.volumetricMin }KG a ${ fixedprice.volumetricMax}KG` : `${ fixedprice.kilometresMin }KM a ${ fixedprice.kilometresMax}KM` }</td>
                <td>{ NumeralMethods.cash(fixedprice.shipmentPrice) }</td>
                <td>
                    <Icon on:click={() => FixedpriceStore.modalRead(fixedprice)} icon="eye" pointer />
                </td>
            </tr>
        {/each}
    </tbody>
</Table>